import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { TActivityList } from "../../../context/ActivityProvider";
import { PaginationTable } from "../../table/PaginationTable";
import { Table } from "../../table/Table";
import NotActivityFound from "../NotActivityFound";
import { BodyTableUserActionsLogs } from "./BodyTableUserActionsLogs";

interface TableActivityProps {
  offset: number;
  setOffset: (value: number) => void;
  limit: number;
  setLimit: (value: number) => void;
  activityList: TActivityList;
  filterNotFound: boolean;
}

export const TableUserActionsLogs = ({
  activityList,
  limit,
  offset,
  setLimit,
  setOffset,
}: TableActivityProps): JSX.Element => {
  const { t } = useTranslation();

  const i18n = (key: string) => t(`activity-directory.table.header.${key}`);

  const isPagination = useMemo(
    () => (activityList?.count ?? 0) > 10,
    [activityList?.count]
  );

  const columns = useMemo(
    () => [
      { id: "full_name", label: i18n("full_name") },
      { id: "email", label: i18n("email") },
      { id: "action", label: i18n("action") },
      { id: "action_key", label: i18n("action_key") },
      { id: "created_stamp", label: i18n("created_stamp") },
      { id: "module_key", label: i18n("module_key") },
    ],
    [t]
  );

  const hasNoData = activityList.count === 0;

  return (
    <div className="relative">
      {isPagination && (
        <PaginationTable
          limit={limit}
          setLimit={setLimit}
          total={activityList?.count ?? 0}
          offset={offset}
          setOffset={setOffset}
        />
      )}

      <Table columns={columns}>
        {hasNoData ? (
          <tr>
            <td colSpan={columns.length} className="text-center py-4">
              <NotActivityFound />
            </td>
          </tr>
        ) : (
          <BodyTableUserActionsLogs
            rows={activityList.results as any[]}
            isPagination={isPagination}
            isLoadingSendInvitation={false}
            handleClickInviteButton={() => {}}
          />
        )}
      </Table>
    </div>
  );
};
